import GlobalAppService from './GlobalAppService';
import { storeIdentifiers, serviceConfigs } from './configs';
// window.showAtsDebugMessage = true;

// Make sure any calls to globalAppService always get the same promise back.
// This gets immediately attached to window so the legacy side will get the same one.
window.$ats.appServiceInitPromise = undefined;

/**
 * For debug only. This will output a stack trace every time the globalAppService singleton is requested.
 * The stack trace can be expanded to see from where the globalAppService is being requested. This will
 * give insight into possible race conditions and other hard to debug issues.
 *
 * This will not fire unless `window.showAtsDebugMessage = true;` is added somewhere early in the code
 * like for example anywhere in this file.
 */
const logServiceRequested = () => {
  if (window.showAtsDebugMessage) {
    // eslint-disable-next-line no-console
    const shutUpEslint = console;
    shutUpEslint.groupCollapsed('🛎️ appService requested.');
    shutUpEslint.trace();
    shutUpEslint.groupEnd();
  }
};

/**
 * This should return a Promise that resolves a singleton of a GlobalAppService.
 * The promise is attached to the window so the legacy side has access to it.
 * @returns Promise<GlobalAppService>
 */
export const globalAppService = async () => {
  logServiceRequested();
  // Enforce the singleton pattern.
  if (window.$ats.appServiceInitPromise) {
    return window.$ats.appServiceInitPromise;
  }
  const globalService = new GlobalAppService();
  window.$ats.appServiceInitPromise = globalService.init({
    name: 'globalAppService',
    storeIdentifiers,
    serviceConfigs,
  });
  window.$ats.appServiceInitPromise.then((appService) => {
    window.$ats.appService = appService;
  });
  return window.$ats.appServiceInitPromise;
};

window.$ats.globalAppServiceInit = globalAppService;
